export default {
    reset(validationObj) {
        for (let prop in validationObj) {
            if (
                Object.prototype.hasOwnProperty.call(
                    validationObj,
                    prop
                )
            ) {

                const propObj = validationObj[prop];
                propObj.hasTouched = false;
                propObj.value = false;

                for (let childProp in propObj) {
                    if (
                        typeof propObj[childProp] === "object" &&
                        propObj[childProp] !== null
                    ) {
                        propObj[childProp].value = false
                    }
                }
            }

        }

    },
    validate(validationObj) {
        let errors = [];

        for (let prop in validationObj) {
            //all properties

            if (
                Object.prototype.hasOwnProperty.call(
                    validationObj,
                    prop
                )
            ) {
                //find the value property
                const propObj = validationObj[prop];

                if (!propObj.hasTouched) {
                    propObj.hasTouched = true;
                }

                //validation didn't pass
                if (!propObj.value) {
                    for (let childProp in propObj) {
                        if (
                            typeof propObj[childProp] === "object" &&
                            propObj[childProp] !== null
                        ) {
                            if (!propObj[childProp].value && propObj[childProp].errorMessage) {
                                errors.push(propObj[childProp].errorMessage);
                            }
                        }
                    }
                }
            }
        }

        return errors;
    },
    validateProperty(validationObject, model, propertyName, propertyValue, vue) {
        for (let prop in validationObject) {
            //all properties
            //if we find the property
            if (
                Object.prototype.hasOwnProperty.call(
                    validationObject,
                    prop
                ) &&
                prop == propertyName
            ) {
                const propObj = validationObject[prop];

                if (!propObj.hasTouched) {
                    propObj.hasTouched = true;
                }

                propObj.value = true;

                let canContinue = false;

                if (propObj.relationships && propObj.relationships.length > 0) {
                    let canContinueCounter = 0;

                    propObj.relationships.forEach(r => {
                        //find the property
                        const field = model[r.field];

                        //if the relationship specifys required, then the relationship field value must have a value
                        if (r.required && field !== null && field !== '') {
                            canContinueCounter += 1;
                        } else if (!r.required && !Array.isArray(r.value) && field === r.value) {
                            //we can continue
                            canContinueCounter += 1;
                        } else if (!r.required && Array.isArray(r.value) && r.value.some(v => v === field)) {
                            canContinueCounter += 1;
                        } else if (!r.required && !r.value && r.notEqualValue && field !== null && field !== '' && field !== r.notEqualValue) {
                            canContinueCounter += 1;
                        }
                    });

                    if (canContinueCounter == propObj.relationships.length && !propObj.ORRelationships) {
                        canContinue = true;
                    } else if (propObj.ORRelationships && canContinueCounter > 0) {
                        canContinue = true;
                    }
                } else {
                    canContinue = true;
                }

                if (canContinue) {
                    //do we have a required validation
                    if (propObj.hasOwnProperty("required")) {
                        if (
                            propertyValue === undefined ||
                            propertyValue == null ||
                            propertyValue.length == 0
                        ) {
                            //Then it's required but the result is invalid
                            propObj.required.value = false;
                            propObj.value = false;
                        } else {

                                propObj.required.value = true;

                        }
                    }
                    if (propObj.hasOwnProperty("callback")) {
                        if (propObj.callback.validationCallback != undefined && propObj.callback.validationCallback(vue)) {
                            propObj.callback.value = false;
                            propObj.value = false;
                        }
                        else {
                            propObj.callback.value = true;
                        }


                    }
                    if (propObj.hasOwnProperty("notEmpty")) {
                        if (
                            propertyValue === undefined ||
                            propertyValue == null ||
                            propertyValue.length == 0
                        ) {
                            propObj.notEmpty.value = false;
                            propObj.value = false;
                        } else {
                            propObj.notEmpty.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("validDate")) {
                        const minDate = new Date();
                        minDate.setDate(1);
                        minDate.setMonth(minDate.getMonth() - 1);

                        //all dates should be no more than one year out
                        const maxDate = new Date();
                        maxDate.setFullYear(maxDate.getFullYear() + 1);

                        const dateProperty = new Date(propertyValue);

                        console.log(minDate, maxDate, dateProperty, propertyValue, propObj.validDate.noMinDate, propObj.validDate.noMaxDate);

                        if (
                            propertyValue === undefined ||
                            propertyValue == null ||
                            propertyValue.length == 0
                        ) {
                            propObj.validDate.value = false;
                            propObj.value = false;
                        } else if (dateProperty < minDate && !propObj.validDate.noMinDate) {
                            //less than the min date
                            propObj.validDate.value = false;
                            propObj.value = false;
                        } else if (dateProperty > maxDate && !propObj.validDate.noMaxDate) {
                            propObj.validDate.value = false;
                            propObj.value = false;
                        } else {
                            propObj.validDate.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("min")) {
                        if (
                            propertyValue != null && propertyValue.length < propObj.min.length
                        ) {
                            propObj.min.value = false;
                            propObj.value = false;
                        } else {
                            propObj.min.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("matchValue")) {

                        if (
                            propertyValue !== propObj.matchValue.equals
                        ) {
                            propObj.matchValue.value = false;
                            propObj.value = false;
                        } else {
                            propObj.matchValue.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("max")) {
                        if (
                            propertyValue != null && propertyValue.length > propObj.max.length
                        ) {
                            propObj.max.value = false;
                            propObj.value = false;
                        } else {
                            propObj.max.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("numeric")) {
                        if (
                            propertyValue != null && isNaN(propertyValue)
                        ) {
                            propObj.numeric.value = false;
                            propObj.value = false;
                        } else {
                            propObj.numeric.value = true;
                        }
                    }
                    if (propObj.hasOwnProperty("range")) {
                        if (
                            propertyValue != null && (parseInt(propertyValue) < propObj.range.min || parseInt(propertyValue) > propObj.range.max)
                        ) {
                            propObj.range.value = false;
                            propObj.value = false;
                        } else {
                            propObj.range.value = true;
                        }
                    }
                }


            }
        }
    }
}